<script setup>
import Heading from "~/components/atoms/Heading.vue";
import Carousel from "~/components/molecules/Carousel.vue";
import BetterWithProduct from "~/components/molecules/ProductPage/BetterWithProduct.vue";
import GreenLabel from "~/components/atoms/GreenLabel.vue";

const props = defineProps({
  sku: {
    type: String,
    required: true
  },
  title: {
    type: String,
  },
  items: {
    type: Array,
    required: true
  },
  label: {
    type: String,
  },
  vertical: {
    type: Boolean,
    default: false
  },
  noPadding: {
    type: Boolean,
    default: false
  },
  gaKey: {
    type: String,
    default: null
  }
})

const SupplementaryModal = createLazyComponent(loadSupplementarySide, 'SupplementaryModal')

const chosenBundle = ref(null)

onMounted(() => {
  if (props.items?.length) {
    preloadOnIdle(() => preloadSupplementarySide())
  }
})

const handleBundleClick = (bundle) => {
  chosenBundle.value = bundle
}
</script>

<template>
  <div class="supplementary g-24" :class="{vertical, 'no-padding':noPadding}">
    <div class="row g-16 column-mobile flex-center mobile-padding title" v-if="props.title || label">
      <Heading tag="h2">{{ props.title }}</Heading>
      <GreenLabel v-if="label">{{ label }}</GreenLabel>
    </div>

    <template v-if="vertical">
      <div class="g-12">
        <template v-for="item in items">
          <BetterWithProduct :vertical="vertical" @click="handleBundleClick" :product="item"/>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="slides">
        <div class="carousel-container">
          <Carousel
              :items-to-show-mobile="2.3"
              :items-to-show-tablet="3.3"
              :items="items"
              :items-to-show="4.3" :itemsToScroll="2" :infinite="true" :dots="false">
            <template #default="{item}">
              <BetterWithProduct @click="handleBundleClick" :product="item"/>
            </template>
          </Carousel>
        </div>
      </div>
    </template>
    <Teleport to="body">
      <SupplementaryModal :gaKey="gaKey"  :sku="props.sku" @close="chosenBundle=null" v-if="chosenBundle" :bundle="chosenBundle"/>
    </Teleport>
  </div>
</template>

<style scoped lang="scss">
.title {
  @include smd {
    align-items: flex-start;
  }
}

.supplementary {
  background: $light-background;
  padding: 15px 0 15px 40px;

  &.vertical {
    padding: 20px;
    gap: 10px;

    @include smd {
      padding: 20px 14px;
    }

    .title {
      @include smd {
        padding-left: 0 !important;
      }
    }

    h2 {
      font-size: 14px;
    }
  }

  &.no-padding {
    padding: 0;
    background: unset;
  }

  @include smd {
    padding: 15px 0 15px 10px;
  }

  @include mobile {
    padding: 10px 10px;
    //margin-right: -16px;
  }
}

.supplementary:deep(.product) {
  &:not(.vertical) {
    max-width: 160px;
  }
}


.slides {
  margin-left: -15px;

  @include smd {
    margin-left: 0;
  }
}
</style>
